import type React from 'react';
import { useState } from 'react';

import styles from './styles';
import RadioGroup from '@material-ui/core/RadioGroup';

import {
  DescriptionListDefault,
  Divider,
  RadioButton,
} from '@cobliteam/base-components';

import Button from '@cobliteam/ui/components/Button';

export enum IssueOption {
  SPEEDING = 'Velocidade da via e do veículo',
  IDlE_ENGINE = 'Motor ocioso',
  DISTANCE_DRIVEN = 'Distância percorrida',
  OTHER = 'Outros',
}

interface SelectIssueModuleProps {
  onClose: () => void;
  onContinue: (issueOption: IssueOption) => void;
}

const SelectIssueModule = ({ onClose, onContinue }: SelectIssueModuleProps) => {
  const [selectedOption, setSelectedOption] = useState<IssueOption | undefined>(
    undefined
  );

  const handleOptionChange = (event: React.ChangeEvent<{}>, value: string) => {
    const newSelectedOption = value as IssueOption;
    setSelectedOption(newSelectedOption);
  };

  const handleOnContinueClick = () => {
    onContinue(selectedOption!);
  };

  return (
    <>
      <div className={styles.contentWrapper}>
        <DescriptionListDefault>
          Selecione o dado que gostaria de opinar*:{' '}
        </DescriptionListDefault>
        <RadioGroup
          value={selectedOption}
          onChange={handleOptionChange}
          className={styles.radioGroup}
        >
          <RadioButton
            value={IssueOption.SPEEDING}
            label={IssueOption.SPEEDING}
          />
          <RadioButton
            value={IssueOption.IDlE_ENGINE}
            label={IssueOption.IDlE_ENGINE}
          />
          <RadioButton
            value={IssueOption.DISTANCE_DRIVEN}
            label={IssueOption.DISTANCE_DRIVEN}
          />
          <RadioButton value={IssueOption.OTHER} label={IssueOption.OTHER} />
        </RadioGroup>
      </div>
      <Divider />
      <div>
        <div className={styles.buttonSection}>
          <Button variant='text' type='button' onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant='contained'
            type='button'
            disabled={selectedOption === undefined}
            onClick={handleOnContinueClick}
          >
            Continuar
          </Button>
        </div>
      </div>
    </>
  );
};

export default SelectIssueModule;
